import React from 'react';
import { Paper } from '@material-ui/core';
import { IndeedPaperProps } from '../IndeedModels';

const IndeedPaper = ({ children, style }: IndeedPaperProps) => {
    return (
        <Paper style={{ ...{ borderRadius: 18, width: '100%', padding: 30 }, ...style }} elevation={4}>
            {children}
        </Paper>
    );
};

export default IndeedPaper;
